import { styled } from "@mui/material";

import withThemeProvider from "@/Components/HigherOrderComponents/withThemeProvider";
import { colors } from "@/Utils";

const ToolTip = styled("div")(({ theme }) => {
  return {
    width: "100%",
    height: "100%",
    fontSize: "12px",
    fontWeight: "500",
    padding: "0.1em",
    backgroundColor: theme.palette.mode === "light" ? colors.white : colors.cardBg,
    color: theme.palette.mode === "light" ? colors.cardBg : colors.white,
    clipPath:
      "polygon(0% 0px, 0px 0%, 0px 0%, 100% 0px, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0px 100%)",
  };
});

const EChartToolTipBaseComponent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <ToolTip> {children} </ToolTip>;
};

const EChartToolTip = withThemeProvider(EChartToolTipBaseComponent);
export default EChartToolTip;
